import { render, staticRenderFns } from "./TaskInstrumentForm.vue?vue&type=template&id=0ed2161e"
import script from "./TaskInstrumentForm.vue?vue&type=script&lang=js"
export * from "./TaskInstrumentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports